import { FormControl, TextField } from "@mui/material";

interface Props {
  name: string;
  setName: (name: string) => void;
  error?: boolean;
  errorMessage?: string;
}

const RunNameSelector = ({ name, setName, error, errorMessage }: Props) => {
  return (
    <FormControl fullWidth>
      <TextField
        fullWidth
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        error={error}
        helperText={errorMessage}
      />
    </FormControl>
  );
};

export default RunNameSelector;
